// ! hazrati imom
import hazratiImom1 from "../../photos/uzb_tosh_hazratimom1.webp";
import hazratiImom2 from "../../photos/uzb_tosh_hazratimom2.webp";
import hazratiImom3 from "../../photos/uzb_tosh_hazratimom3.webp";

// ! chorsu bozori
import chorsu1 from "../../photos/uzb_tosh_chorsu1.webp";
import chorsu2 from "../../photos/uzb_tosh_chorsu2.webp";
import chorsu3 from "../../photos/uzb_tosh_chorsu3.webp";

// ! amir temur maydoni
import amir1 from "../../photos/uzb_tosh_amirmaydon1.webp";
import amir2 from "../../photos/uzb_tosh_amirmaydon2.webp";
import amir3 from "../../photos/uzb_tosh_amirmaydon3.webp";

// ! toshkent muzeyi
import muzey1 from "../../photos/uzb_tosh_muzey1.webp";
import muzey2 from "../../photos/uzb_tosh_muzey2.webp";
import muzey3 from "../../photos/uzb_tosh_muzey3.webp";

// ! toshkent metrosi
import metro1 from "../../photos/uzb_tosh_metro1.webp";
import metro2 from "../../photos/uzb_tosh_metro2.webp";
import metro3 from "../../photos/uzb_tosh_metro3.webp";




const tashkent = {
    uz: {
        key: "tashkent",
        title: "Toshkent — zamonaviy va tarixiy poytaxt",

        intro: `
Toshkent — O‘zbekistonning poytaxti va eng katta shahri.
Bu yerda zamonaviy hayot va qadimiy tarix birlashgan.
  `,

        history: `
Toshkent — O‘zbekiston poytaxti va Markaziy Osiyodagi eng yirik shaharlardan biri bo‘lib, 2200 yildan ortiq tarixga ega.

Qadimda u “Chach” va “Shosh” nomlari bilan tanilgan bo‘lib, Buyuk Ipak Yo‘lida muhim savdo markazi bo‘lgan. Bu yerda karvonlar to‘xtab, savdo va almashinuvlar amalga oshirilgan.

VIII asrda Toshkent arablar ta’siriga tushgan, keyinchalik turli davlatlar qo‘l ostida rivojlangan.

XIX asrda Rossiya imperiyasi tomonidan bosib olingan va zamonaviy shahar qurilishi boshlanib, yangi infratuzilma paydo bo‘lgan.

1966-yilgi kuchli zilzila Toshkentni deyarli vayron qilgan, ammo shahar tezda qayta qurilib, keng ko‘chalar va zamonaviy binolar bilan yangi poytaxtga aylangan.

Bugungi kunda Toshkent — siyosiy, iqtisodiy va madaniy markaz bo‘lib, zamonaviy metropol sifatida rivojlanmoqda.
`,

        sections: [
            {
                title: "Hazrati Imom Majmuasi — Toshkent",

                content: `
Hazrati Imom Majmuasi Toshkent shahrining eng qadimiy va muqaddas tarixiy maskanlaridan biridir.

Majmua eski Toshkent hududida joylashgan bo‘lib, islomiy me’morchilik, tarix va ma’naviyat markazi sifatida mashhur hisoblanadi.

Bu yerda qadimiy masjidlar, madrasalar, maqbaralar va noyob qo‘lyozmalar saqlanadi.
Majmua o‘zining moviy gumbazlari, sharqona naqshlari va sokin muhit bilan tashrif buyuruvchilarga unutilmas taassurot qoldiradi.

Hazrati Imom majmuasi nafaqat diniy markaz, balki Toshkentning eng muhim turistik maskanlaridan biri hisoblanadi.
    `,

                details: `
Majmua mashhur islom olimi Hazrati Imom — Abu Bakr Muhammad Kaffol Shoshiy nomi bilan atalgan.

Kompleks tarkibiga:
- Baroqxon madrasasi
- Tilla Shayx masjidi
- Muyi Muborak madrasasi
- Hazrati Imom maqbarasi
- Namozgoh masjidi

kabi tarixiy obidalar kiradi.

Majmuaning eng mashhur eksponatlaridan biri — Usmon Qur’oni hisoblanadi.
Bu Qur’on dunyodagi eng qadimiy Qur’on nusxalaridan biri sifatida tanilgan.

Hazrati Imom majmuasi kechki yoritish tizimi, sharqona arxitekturasi va tarixiy muhiti bilan sayyohlar uchun juda mashhur joy hisoblanadi.
    `,

                facts: `
- Toshkent shahrining eski qismida joylashgan
- Abu Bakr Kaffol Shoshiy nomi bilan atalgan
- O‘zbekistonning eng muqaddas maskanlaridan biri
- Usmon Qur’oni shu yerda saqlanadi
- Baroqxon madrasasi majmuaning asosiy qismlaridan biri
- XVI asrga oid tarixiy obidalar mavjud
- Har yili minglab sayyohlar tashrif buyuradi
- Sharqona va islomiy arxitektura bilan mashhur
- Kechki yoritish dizayni juda mashhur
- Toshkentning eng muhim diniy va madaniy markazlaridan biri
    `,

                images: [hazratiImom1, hazratiImom2, hazratiImom3]

            },

            {
                title: "Chorsu bozori — Sharq yuragi",
                content: `
Chorsu bozori Toshkentning eng jonli joylaridan biri.
Bu yerda ziravorlar, mevalar, non va milliy taomlar sotiladi.

Bozorning gumbazi va rang-barang muhit sayyohlarni o‘ziga tortadi.

Chorsu bozori nafaqat savdo markazi, balki madaniy va ijtimoiy hayotning markazi ham hisoblanadi. Bu yerda mahalliy aholi va sayyohlar birgalikda vaqt o‘tkazishadi, milliy taomlarni tatib ko‘rishadi va o‘zaro muloqot qilishadi. Bozorning gumbazi esa Toshkentning ramzlaridan biri hisoblanadi va ko‘plab odamlar uning oldida suratga tushishni xohlaydi.

U yerda ko‘plab madaniy va ijtimoiy tadbirlar uchun markaz hisoblanadi.


      `,

                details: `
            Chorsu bozori Toshkentning eng mashhur joylaridan biri bo‘lib, har kuni minglab odamlar tashrif buyuradi. Bozorning atrofida zamonaviy arxitektura va tarixiy binolar uyg‘unlashgan bo‘lib, bu yerda sayyohlar va mahalliy aholi birgalikda vaqt o‘tkazishadi.
            `,

                // chorsu bozorining factslari 10ta
                facts: `
- Toshkentning markazida joylashgan
- Har kuni minglab odamlar tashrif buyuradi
- Atrofida zamonaviy arxitektura va tarixiy binolar uyg‘unlashgan
- Ko‘plab madaniy va ijtimoiy tadbirlar uchun markaz hisoblanadi
- Ziravorlar, mevalar, non va milliy taomlar sotiladi
- Bozorning gumbazi Toshkentning ramzlaridan biri hisoblanadi
- Ko‘plab odamlar uning oldida suratga tushishni xohlaydi
- Mahalliy aholi va sayyohlar birgalikda vaqt o‘tkazishadi
- Milliy taomlarni tatib ko‘rishadi
- O‘zaro muloqot qilishadi`,
                images: [chorsu1, chorsu2, chorsu3,]
            },

            {
                title: "Amir Temur maydoni",
                content: `
Shahar markazida joylashgan bu maydon Amir Temur sharafiga qurilgan.
Atrofida mehmonxonalar, muzeylar va bog‘lar joylashgan. Maydonning markazida Amir Temurning haykali o‘rnatilgan bo‘lib, u O‘zbekistonning milliy qahramoni sifatida hurmat qilinadi. Maydon ko‘plab madaniy va ijtimoiy tadbirlar uchun markaz hisoblanadi. 
      `,
                details: `
Amir Temur maydoni Toshkentning eng mashhur joylaridan biri bo‘lib, har kuni minglab odamlar tashrif buyuradi. Maydonning atrofida zamonaviy arxitektura va tarixiy binolar uyg‘unlashgan bo‘lib, bu yerda sayyohlar va mahalliy aholi birgalikda vaqt o‘tkazishadi.

Amir Temur maydoni nafaqat tarixiy ahamiyatga ega, balki zamonaviy hayotning markazi ham hisoblanadi. Bu yerda ko‘plab restoranlar, kafe va do‘konlar joylashgan bo‘lib, sayyohlar va mahalliy aholi uchun qulay sharoitlar yaratadi. Maydonning markazida joylashgan haykal esa O‘zbekistonning milliy qahramoni sifatida hurmat qilinadi va ko‘plab odamlar uning oldida suratga tushishni xohlaydi.
    `,

                // amir temur maydonining factslari 10ta
                facts: `
- Toshkentning markazida joylashgan
- Amir Temur sharafiga qurilgan
- Markazida Amir Temurning haykali o‘rnatilgan
- Har kuni minglab odamlar tashrif buyuradi
- Atrofida zamonaviy arxitektura va tarixiy binolar uyg‘unlashgan
- Ko‘plab restoranlar, kafe va do‘konlar joylashgan
- Sayyohlar va mahalliy aholi uchun qulay sharoitlar yaratadi.
- O‘zbekistonning milliy qahramoni sifatida hurmat qilinadi
- Ko‘plab odamlar uning oldida suratga tushishni xohlaydi`,
                images: [amir1, amir2, amir3,]
            },

            {
                title: "Islom Sivilizatsiyasi Markazi — Toshkent",

                content: `
O‘zbekiston Islom Sivilizatsiyasi Markazi Toshkent shahridagi eng zamonaviy va yirik madaniy-ma’rifiy majmualardan biridir.

Markaz Hazrati Imom majmuasi hududida joylashgan bo‘lib, O‘zbekistonning boy islomiy merosi va buyuk allomalari tarixini dunyoga tanitish maqsadida qurilgan.

Majmua sharqona va zamonaviy arxitektura uyg‘unligida bunyod etilgan bo‘lib, ulkan moviy gumbazi va hashamatli dizayni bilan ajralib turadi.

Bu yerda qadimiy qo‘lyozmalar, tarixiy eksponatlar, interaktiv texnologiyalar va islom sivilizatsiyasiga oid noyob ma’lumotlar namoyish etiladi.
    `,

                details: `
Markazning asosiy maqsadi — O‘zbekiston hududidan yetishib chiqqan buyuk allomalar va islom sivilizatsiyasining jahon taraqqiyotiga qo‘shgan hissasini keng targ‘ib qilishdir.

Majmua ichida:
- Qur’on zali va qadimiy qo‘lyozmalar
- Birinchi va Ikkinchi Renessans bo‘limlari
- Imom Buxoriy, Beruniy, Ibn Sino kabi allomalar merosi
- Zamonaviy multimedia va AI texnologiyalari
- Ilmiy kutubxona va konferensiya zallari

joylashgan.

Markazning ichki dizayni ham juda hashamatli bo‘lib, sharqona naqshlar, katta ustunlar va zamonaviy yoritish tizimi bilan bezatilgan.
    `,

                facts: `
- Toshkent shahrida joylashgan
- Hazrati Imom majmuasi hududida qurilgan
- 65 metrlik ulkan gumbazga ega
- O‘zbekistonning eng zamonaviy muzey majmualaridan biri
- Islom tarixi va allomalar merosiga bag‘ishlangan
- Har yili minglab mahalliy va xorijiy sayyohlar tashrif buyuradi
    `,

                images: [
                    muzey1,
                    muzey2,
                    muzey3,
                ]
            },

            {
                title: "Toshkent Metropoliteni — Yerosti Metro",

                content: `
Toshkent Metropoliteni O‘zbekiston poytaxtining eng mashhur va zamonaviy transport tizimlaridan biridir.

Metro 1977-yilda ishga tushirilgan bo‘lib, Markaziy Osiyodagi birinchi metro hisoblanadi.

Toshkent metrosi nafaqat transport vositasi, balki yerosti san’at muzeyi sifatida ham mashhur.
Har bir bekat o‘ziga xos dizayn, milliy naqshlar, marmar ustunlar, yoritish tizimi va san’at elementlari bilan bezatilgan.

Metro shaharning turli hududlarini tez va qulay bog‘lab, har kuni minglab yo‘lovchilarga xizmat ko‘rsatadi.
    `,

                details: `
Toshkent metrosining qurilishi 1966-yildagi kuchli zilziladan keyin boshlangan.
Metro bekatlari zilzilaga chidamli qilib loyihalashtirilgan bo‘lib, kuchli yer silkinishlariga bardosh bera oladi.

Metro tarkibiga:
- Chilonzor yo‘nalishi
- O‘zbekiston yo‘nalishi
- Yunusobod yo‘nalishi
- Halqa yo‘nalishi

kiradi.

Kosmonavtlar, Alisher Navoiy, Paxtakor va Mustaqillik Maydoni bekatlari eng mashhur va chiroyli bekatlardan hisoblanadi.

Metro ichida milliy bezaklar, sovet modernizmi va sharqona arxitektura uyg‘unlashgan bo‘lib, ko‘plab sayyohlarni jalb qiladi.

2018-yildan boshlab metro ichida surat va video olishga ruxsat berilgan va shundan keyin Toshkent metrosi internetda juda mashhur bo‘lib ketgan.
    `,

                facts: `
- 1977-yilda ochilgan
- Markaziy Osiyodagi birinchi metro
- 4 ta asosiy yo‘nalishga ega
- 50 dan ortiq bekatlar mavjud
- Har bir bekat alohida dizaynga ega
- Metro zilzilaga chidamli qilib qurilgan
- Kosmonavtlar bekati eng mashhur bekatlardan biri
- 2018-yilgacha suratga olish taqiqlangan edi
- Har kuni yuz minglab yo‘lovchilar foydalanadi
- Toshkent metrosi yerosti san’at muzeyi sifatida mashhur
    `,
                images: [metro1, metro2, metro3,]
            }
        ]
    },


    ru: {
        key: "tashkent",
        title: "Ташкент — современная и историческая столица",

        intro: `
Ташкент — столица Узбекистана и крупнейший город страны.
Здесь гармонично сочетаются современная жизнь и многовековая история.
    `,

        history: `
Ташкент — столица Республики Узбекистан и один из крупнейших городов Центральной Азии с историей, насчитывающей более 2200 лет.

В древности город был известен под названиями «Чач» и «Шаш» и являлся важнейшим торговым центром на Великом шелковом пути. Через него проходили многочисленные караваны, что способствовало развитию торговли, ремёсел и культурного обмена между Востоком и Западом.

В VIII веке Ташкент вошёл в сферу влияния арабов, а в последующие столетия развивался в составе различных государств и династий, оставаясь одним из крупнейших городов региона.

Во второй половине XIX века город был присоединён к Российской империи. Именно в этот период началось активное строительство новых кварталов, дорог и современной городской инфраструктуры.

В 1966 году сильное землетрясение практически разрушило большую часть города. Однако Ташкент был быстро восстановлен и превратился в современную столицу с широкими проспектами, просторными площадями, зелёными парками и современной архитектурой.

Сегодня Ташкент является политическим, экономическим, культурным и научным центром Узбекистана. Это динамично развивающийся мегаполис, где историческое наследие органично сочетается с современной городской жизнью.
`,
        sections: [
            {
                title: "Комплекс Хазрати Имам — Ташкент",

                content: `
Комплекс Хазрати Имам — одно из древнейших и самых священных исторических мест Ташкента.

Расположенный в Старом городе, комплекс является известным центром исламской архитектуры, истории и духовной культуры.

Здесь находятся древние мечети, медресе, мавзолеи и уникальные рукописи.
Благодаря своим голубым куполам, изысканным восточным орнаментам и спокойной атмосфере комплекс оставляет незабываемые впечатления у посетителей.

Комплекс Хазрати Имам является не только важным религиозным центром, но и одной из главных туристических достопримечательностей Ташкента.
    `,

                details: `
Комплекс назван в честь выдающегося исламского учёного Хазрати Имама — Абу Бакра Мухаммада Каффаля аш-Шаши.

В состав комплекса входят:
- Медресе Баракхан
- Мечеть Тилла-Шейх
- Медресе Муйи Муборак
- Мавзолей Хазрати Имама
- Мечеть Намазгох

Одним из самых ценных экспонатов комплекса является Коран Усмана.
Он считается одним из древнейших сохранившихся экземпляров Корана в мире.

Комплекс Хазрати Имам особенно популярен благодаря своей вечерней подсветке, великолепной восточной архитектуре и уникальной исторической атмосфере.
    `,

                facts: [
                    "Расположен в Старом городе Ташкента",
                    "Назван в честь Абу Бакра Каффаля аш-Шаши",
                    "Одно из самых священных мест Узбекистана",
                    "Здесь хранится Коран Усмана",
                    "Медресе Баракхан является одной из главных частей комплекса",
                    "Включает исторические памятники XVI века",
                    "Ежегодно его посещают тысячи туристов",
                    "Известен исламской и восточной архитектурой",
                    "Особенно красив благодаря вечерней подсветке",
                    "Один из важнейших религиозных и культурных центров Ташкента"
                ],

                images: [hazratiImom1, hazratiImom2, hazratiImom3]
            },

            {
                title: "Базар Чорсу — сердце Востока",

                content: `
Базар Чорсу — одно из самых оживлённых и колоритных мест Ташкента.

Здесь продаются ароматные специи, свежие фрукты, традиционный узбекский хлеб и национальные блюда.

Знаменитый голубой купол рынка и его яркая атмосфера привлекают тысячи туристов со всего мира.

Чорсу — это не только торговая площадка, но и важный центр культурной и общественной жизни города. Здесь местные жители и гости столицы встречаются, пробуют блюда узбекской кухни, знакомятся с традициями и ощущают настоящий восточный колорит.

На территории рынка регулярно проходят культурные мероприятия, а его знаменитый купол давно стал одним из символов Ташкента и популярным местом для фотографий.
    `,

                details: `
Базар Чорсу является одним из самых известных рынков Ташкента и ежедневно принимает тысячи посетителей.

Вокруг рынка гармонично сочетаются современные здания и историческая архитектура, создавая неповторимую атмосферу старого и нового города.

Здесь можно приобрести свежие овощи и фрукты, восточные сладости, сухофрукты, орехи, традиционные ремесленные изделия, текстиль и сувениры.

Базар остаётся важным местом встречи жителей города и одной из самых ярких достопримечательностей столицы Узбекистана.
    `,

                facts: [
                    "Расположен в центре Ташкента",
                    "Ежедневно принимает тысячи посетителей",
                    "Окружён современной и исторической архитектурой",
                    "Является важным культурным и общественным центром",
                    "Здесь продаются специи, фрукты, узбекский хлеб и национальные блюда",
                    "Знаменитый купол считается одним из символов Ташкента",
                    "Популярное место для фотографий",
                    "Любимое место встреч жителей и туристов",
                    "Отличное место для знакомства с узбекской кухней",
                    "Один из самых известных традиционных рынков Центральной Азии"
                ],

                images: [chorsu1, chorsu2, chorsu3],
            },
            {
                title: "Площадь Амира Темура",

                content: `
Площадь Амира Темура — одна из главных достопримечательностей и символов современного Ташкента.

Расположенная в самом центре столицы, площадь была создана в честь великого полководца и государственного деятеля Амира Темура.

В центре площади установлен величественный памятник Амиру Темуру, который считается национальным героем Узбекистана.

Площадь окружена гостиницами, музеями, зелёными парками и административными зданиями, а также служит местом проведения различных культурных и общественных мероприятий.
    `,

                details: `
Площадь Амира Темура является одним из самых посещаемых мест Ташкента и ежедневно привлекает тысячи жителей и туристов.

Её окружают современные архитектурные сооружения и исторические здания, что создаёт гармоничное сочетание прошлого и настоящего.

Помимо своего исторического значения, площадь является важным общественным пространством города. Поблизости расположены многочисленные рестораны, кафе, магазины и гостиницы, создающие комфортную атмосферу для отдыха и прогулок.

Памятник Амиру Темуру остаётся одним из самых узнаваемых символов Узбекистана и популярным местом для фотографирования.
    `,

                facts: [
                    "Расположена в центре Ташкента",
                    "Названа в честь Амира Темура",
                    "В центре установлен памятник Амиру Темуру",
                    "Ежедневно её посещают тысячи людей",
                    "Окружена современной и исторической архитектурой",
                    "Рядом расположены рестораны, кафе и магазины",
                    "Популярное место отдыха жителей и туристов",
                    "Амир Темур считается национальным героем Узбекистана",
                    "Одно из самых популярных мест для фотографий",
                    "Является одной из главных достопримечательностей столицы"
                ],

                images: [amir1, amir2, amir3],
            },
            {
                title: "Центр исламской цивилизации — Ташкент",

                content: `
Центр исламской цивилизации Узбекистана — один из крупнейших и самых современных культурно-просветительских комплексов страны.

Он расположен на территории комплекса Хазрати Имам и создан с целью познакомить мир с богатым исламским наследием Узбекистана и выдающимися учёными, внесшими огромный вклад в развитие мировой науки и культуры.

Комплекс сочетает традиционные восточные архитектурные мотивы с современными инженерными решениями. Его величественный голубой купол и роскошный дизайн делают центр одной из новых архитектурных достопримечательностей Ташкента.

Здесь представлены древние рукописи, исторические экспонаты, интерактивные технологии и уникальные материалы, посвящённые истории исламской цивилизации.
    `,

                details: `
Главная миссия Центра — популяризация научного и духовного наследия великих мыслителей, родившихся на территории современного Узбекистана, а также демонстрация вклада исламской цивилизации в развитие мировой науки.

В комплексе расположены:
- Зал Священного Корана и древних рукописей
- Экспозиции, посвящённые Первому и Второму Восточному Возрождению
- Разделы, посвящённые Имаму аль-Бухари, аль-Бируни, Ибн Сине и другим великим учёным
- Современные мультимедийные и AI-технологии
- Научная библиотека и конференц-залы

Интерьер центра отличается особой роскошью: изящные восточные орнаменты, величественные колонны и современная система освещения создают уникальную атмосферу, объединяющую историю и современные технологии.
    `,

                facts: [
                    "Расположен в городе Ташкент",
                    "Построен на территории комплекса Хазрати Имам",
                    "Имеет величественный купол высотой около 65 метров",
                    "Один из самых современных музейных комплексов Узбекистана",
                    "Посвящён истории ислама и наследию великих учёных",
                    "Ежегодно принимает тысячи местных и иностранных посетителей"
                ],

                images: [
                    muzey1,
                    muzey2,
                    muzey3,
                ]
            },
            {
                title: "Ташкентский метрополитен — подземный музей",

                content: `
Ташкентский метрополитен — одна из самых известных и современных транспортных систем столицы Узбекистана.

Метро было открыто в 1977 году и стало первым метрополитеном в Центральной Азии.

Ташкентское метро известно не только как удобный вид транспорта, но и как настоящий подземный музей искусства.
Каждая станция имеет свой уникальный дизайн, украшена национальными орнаментами, мраморными колоннами, красивым освещением и элементами декоративного искусства.

Метро соединяет различные районы города и ежедневно обслуживает тысячи пассажиров.
    `,

                details: `
Строительство Ташкентского метрополитена началось после сильного землетрясения 1966 года.

Станции метро были спроектированы с учётом высокой сейсмостойкости и способны выдерживать сильные землетрясения.

В состав метро входят:
- Чиланзарская линия
- Узбекистанская линия
- Юнусабадская линия
- Кольцевая линия

Самыми известными и красивыми станциями считаются:
- Космонавтов
- Алишера Навои
- Пахтакор
- Площадь Независимости

В оформлении метро сочетаются национальные мотивы, советский модернизм и восточная архитектура, что привлекает большое количество туристов.

С 2018 года в ташкентском метро разрешили фотографировать и снимать видео, после чего оно стало ещё более популярным среди путешественников.
    `,

                facts: [
                    "Открыт в 1977 году",
                    "Первый метрополитен в Центральной Азии",
                    "Имеет 4 основные линии",
                    "Включает более 50 станций",
                    "Каждая станция имеет уникальный дизайн",
                    "Построен с учётом сейсмостойкости",
                    "Станция Космонавтов является одной из самых известных",
                    "До 2018 года фото- и видеосъёмка была запрещена",
                    "Ежедневно метро используют сотни тысяч пассажиров",
                    "Ташкентский метрополитен считается подземным музеем искусства",
                    "Станции украшены мрамором и национальными орнаментами",
                    "Является одним из символов современного Ташкента",
                    "Привлекает множество иностранных туристов",
                    "Сочетает восточную архитектуру и современный дизайн",
                    "Один из самых красивых метрополитенов региона",
                    "Соединяет разные районы столицы",
                    "Имеет историческое и культурное значение",
                    "Был построен после землетрясения 1966 года",
                    "Каждая станция рассказывает свою историю",
                    "Ночью и при освещении станции выглядят особенно красиво"
                ],

                images: [metro1, metro2, metro3,]
            },
        ]
    },
    en: {
        key: "tashkent",
        title: "Tashkent — A Modern and Historic Capital",

        intro: `
Tashkent is the capital of Uzbekistan and the largest city in the country.
It is a place where modern lifestyle and ancient history come together.
    `,

        history: `
Tashkent is the capital of Uzbekistan and one of the largest cities in Central Asia, with more than 2200 years of history.

In ancient times, it was known as “Chach” and “Shash” and was an important trading center on the Great Silk Road. Caravans stopped here, and trade and cultural exchanges took place between East and West.

In the 8th century, Tashkent came under Arab influence and later developed under various states and dynasties.

In the 19th century, the city was conquered by the Russian Empire, after which modern urban development began and new infrastructure appeared.

The devastating earthquake of 1966 almost destroyed Tashkent, but the city was quickly rebuilt with wide streets, modern buildings, and a new urban design.

Today, Tashkent is the political, economic, and cultural center of Uzbekistan, developing as a modern metropolis.
    `,

        sections: [
            {
                title: "Hazrati Imam Complex — Tashkent",

                content: `
The Hazrati Imam Complex is one of the oldest and most sacred historical places in Tashkent.

The complex is located in the old part of Tashkent and is famous as a center of Islamic architecture, history, and spirituality.

It preserves ancient mosques, madrasas, mausoleums, and rare manuscripts.
The complex impresses visitors with its blue domes, traditional Eastern ornaments, and peaceful atmosphere.

Hazrati Imam is not only a religious center but also one of the most important tourist attractions of Tashkent.
    `,

                details: `
The complex is named after the famous Islamic scholar Hazrati Imam — Abu Bakr Muhammad Kaffal Shashi.

The complex includes several historical monuments:
- Barak Khan Madrasah
- Tilla Sheikh Mosque
- Muyi Muborak Madrasah
- Hazrati Imam Mausoleum
- Namazgah Mosque

One of the most valuable exhibits of the complex is the Uthman Quran.

This Quran is considered one of the oldest surviving copies of the Holy Quran in the world.

The Hazrati Imam Complex is especially popular among tourists because of its evening lighting, Eastern architecture, and unique historical atmosphere.
    `,

                facts: [
                    "Located in the old part of Tashkent",
                    "Named after Abu Bakr Kaffal Shashi",
                    "One of the most sacred places in Uzbekistan",
                    "The Uthman Quran is preserved here",
                    "Barak Khan Madrasah is one of the main parts of the complex",
                    "Contains historical monuments from the 16th century",
                    "Visited by thousands of tourists every year",
                    "Famous for Eastern and Islamic architecture",
                    "Known for its beautiful evening lighting design",
                    "One of the most important religious and cultural centers of Tashkent"
                ],

                images: [
                    hazratiImom1,
                    hazratiImom2,
                    hazratiImom3
                ]
            },
            {
                title: "Chorsu Bazaar — The Heart of the East",

                content: `
Chorsu Bazaar is one of the most lively and colorful places in Tashkent.

Here visitors can find traditional products such as spices, fresh fruits, bread, and national dishes.

The huge blue dome of the bazaar and its vibrant atmosphere attract both locals and tourists.

Chorsu Bazaar is not only a trading place but also an important center of cultural and social life. People gather here to experience traditional food, communicate with each other, and discover Uzbek culture.

The famous dome of Chorsu Bazaar has become one of the symbols of Tashkent, and many visitors enjoy taking photos in front of it.

The bazaar also serves as a place for various cultural and social events.
    `,

                details: `
Chorsu Bazaar is one of the most famous attractions in Tashkent, visited by thousands of people every day.

The area around the bazaar combines modern architecture with historical buildings, creating a unique atmosphere where tourists and local residents spend time together.

For centuries, Chorsu Bazaar has been an important trade center where merchants, travelers, and local people exchanged goods and traditions.

Today, it remains one of the best places to experience authentic Uzbek culture, taste national cuisine, and feel the atmosphere of traditional Eastern markets.
    `,

                facts: [
                    "Located in the center of Tashkent",
                    "Visited by thousands of people every day",
                    "Combines modern architecture with historical surroundings",
                    "A center for cultural and social activities",
                    "Famous for spices, fruits, bread, and national dishes",
                    "The large dome is one of the symbols of Tashkent",
                    "A popular place for photography",
                    "A meeting place for locals and tourists",
                    "Visitors can taste traditional Uzbek food here",
                    "One of the most famous traditional markets in Uzbekistan"
                ],

                images: [chorsu1, chorsu2, chorsu3,]
            },
            {
                title: "Amir Temur Square — Tashkent",

                content: `
Amir Temur Square is one of the most famous and important places in the center of Tashkent.

The square was created in honor of Amir Temur, the great commander and founder of the Timurid Empire.

Surrounded by hotels, museums, and beautiful parks, the square represents the historical and modern identity of the city.

In the center of the square stands the monument of Amir Temur, who is respected as one of the national heroes of Uzbekistan.

Today, the square is an important place for cultural events, public gatherings, and tourism.
    `,

                details: `
Amir Temur Square is one of the most visited places in Tashkent, attracting thousands of people every day.

The area around the square combines modern architecture with historical buildings, creating a unique atmosphere where tourists and local residents spend their time.

The square is not only a historical landmark but also a center of modern urban life.

There are many restaurants, cafes, shops, and entertainment areas nearby, providing comfortable conditions for visitors.

The monument of Amir Temur located in the center of the square is highly respected and is one of the most photographed places in Tashkent.
    `,

                facts: [
                    "Located in the center of Tashkent",
                    "Created in honor of Amir Temur",
                    "The monument of Amir Temur is located in the center of the square",
                    "Visited by thousands of people every day",
                    "Surrounded by modern buildings and historical landmarks",
                    "Many restaurants, cafes, and shops are located nearby",
                    "A comfortable place for tourists and local residents",
                    "Amir Temur is respected as a national hero of Uzbekistan",
                    "One of the most photographed places in Tashkent",
                    "An important cultural and social center of the city"
                ],

                images: [amir1, amir2, amir3,]
            },
            {
                title: "Center of Islamic Civilization — Tashkent",

                content: `
The Center of Islamic Civilization in Uzbekistan is one of the largest and most modern cultural and educational complexes in Tashkent.

The center is located near the Hazrati Imam Complex and was built to present the rich Islamic heritage of Uzbekistan and the achievements of great scholars to the world.

The complex combines traditional Eastern architecture with modern design and stands out with its huge blue dome and magnificent appearance.

The center displays ancient manuscripts, historical artifacts, interactive technologies, and unique information about Islamic civilization.
    `,

                details: `
The main goal of the Center of Islamic Civilization is to promote the contribution of Uzbek scholars and the Islamic civilization of the region to world development.

Inside the complex there are:
- Quran Hall and ancient manuscripts
- Sections dedicated to the First and Second Renaissance periods
- Heritage of great scholars such as Imam Bukhari, Al-Biruni, and Ibn Sina
- Modern multimedia and AI technologies
- Scientific library and conference halls

The interior design of the center is also impressive, featuring traditional Eastern patterns, large columns, and modern lighting systems.

The complex represents the connection between Uzbekistan’s historical heritage and modern scientific development.
    `,

                facts: [
                    "Located in Tashkent",
                    "Built near the Hazrati Imam Complex",
                    "Features a huge 65-meter dome",
                    "One of the most modern museum complexes in Uzbekistan",
                    "Dedicated to Islamic history and the heritage of great scholars",
                    "Presents ancient manuscripts and historical artifacts",
                    "Uses modern multimedia technologies",
                    "Combines Eastern architecture with modern design",
                    "Attracts local and international tourists",
                    "Promotes the contribution of Uzbek scholars to world civilization"
                ],

                images: [
                    muzey1,
                    muzey2,
                    muzey3,
                ]
            },
            {
                title: "Tashkent Metro — The Underground Museum",

                content: `
The Tashkent Metro is one of the most famous and modern transportation systems in the capital of Uzbekistan.

The metro was opened in 1977 and became the first underground railway system in Central Asia.

Tashkent Metro is known not only as a means of transportation but also as a real underground museum of art.

Each station has its own unique design, decorated with national ornaments, marble columns, beautiful lighting systems, and artistic elements.

The metro connects different areas of the city quickly and comfortably, serving thousands of passengers every day.
    `,

                details: `
Construction of the Tashkent Metro began after the devastating earthquake of 1966.

The metro stations were designed with strong seismic resistance and built to withstand powerful earthquakes.

The metro system includes:
- Chilonzor Line
- Uzbekistan Line
- Yunusobod Line
- Circle Line

The most famous and beautiful stations include:
- Kosmonavtlar Station
- Alisher Navoi Station
- Pakhtakor Station
- Mustaqillik Maydoni Station

The interior design of the metro combines national decorations, Soviet modernism, and Eastern architectural traditions, attracting many tourists.

Since 2018, photography and video recording have been allowed inside the metro, making Tashkent Metro even more popular among travelers.
    `,

                facts: [
                    "Opened in 1977",
                    "The first metro system in Central Asia",
                    "Has 4 main lines",
                    "Includes more than 50 stations",
                    "Each station has its own unique design",
                    "Built with earthquake-resistant technology",
                    "Kosmonavtlar Station is one of the most famous stations",
                    "Photography was prohibited until 2018",
                    "Used by hundreds of thousands of passengers every day",
                    "Known as an underground museum of art",
                    "Stations are decorated with marble and national ornaments",
                    "One of the symbols of modern Tashkent",
                    "Attracts many international tourists",
                    "Combines Eastern architecture with modern design",
                    "One of the most beautiful metro systems in Central Asia",
                    "Connects different districts of the capital",
                    "Has historical and cultural importance",
                    "Built after the 1966 earthquake",
                    "Each station has its own unique story",
                    "Looks especially beautiful with evening lighting"
                ],

                images: [metro1, metro2, metro3,]
            }
        ]
    },

    fr: {
        key: "tashkent",
        title: "Tachkent — Une capitale moderne et historique",

        intro: `
Tachkent est la capitale de l’Ouzbékistan et la plus grande ville du pays.
C’est un endroit où la vie moderne et l’histoire ancienne se rencontrent.
    `,

        history: `
Tachkent est la capitale de l’Ouzbékistan et l’une des plus grandes villes d’Asie centrale, avec plus de 2200 ans d’histoire.

Dans l’Antiquité, elle était connue sous les noms de « Chach » et « Shash » et constituait un important centre commercial sur la Route de la Soie. Les caravanes y faisaient halte et les échanges commerciaux et culturels entre l’Orient et l’Occident y étaient nombreux.

Au VIIIe siècle, Tachkent passa sous l’influence arabe, puis continua son développement sous différents États et dynasties.

Au XIXe siècle, la ville fut conquise par l’Empire russe, ce qui marqua le début d’une nouvelle période de développement urbain avec de nouvelles infrastructures.

Le puissant tremblement de terre de 1966 détruisit une grande partie de Tachkent, mais la ville fut rapidement reconstruite avec de larges avenues, des bâtiments modernes et une nouvelle organisation urbaine.

Aujourd’hui, Tachkent est le centre politique, économique et culturel de l’Ouzbékistan, évoluant comme une métropole moderne.
    `,

        sections: [
            {
                title: "Complexe Hazrati Imam — Tachkent",

                content: `
Le complexe Hazrati Imam est l’un des lieux historiques les plus anciens et les plus sacrés de Tachkent.

Situé dans la vieille ville de Tachkent, ce complexe est un important centre de l’architecture islamique, de l’histoire et de la spiritualité.

Il abrite d’anciennes mosquées, des médersas, des mausolées et de précieux manuscrits.
Le complexe impressionne les visiteurs par ses dômes bleus, ses ornements orientaux traditionnels et son atmosphère paisible.

Le complexe Hazrati Imam n’est pas seulement un centre religieux, mais aussi l’un des sites touristiques les plus importants de Tachkent.
    `,

                details: `
Le complexe porte le nom du célèbre savant islamique Hazrati Imam — Abu Bakr Muhammad Kaffal Shashi.

Le complexe comprend plusieurs monuments historiques :
- La médersa Barak Khan
- La mosquée Tilla Sheikh
- La médersa Muyi Muborak
- Le mausolée Hazrati Imam
- La mosquée Namazgah

L’un des objets les plus précieux conservés dans le complexe est le Coran d’Othman.

Ce manuscrit est considéré comme l’une des plus anciennes copies du Saint Coran encore existantes dans le monde.

Le complexe Hazrati Imam est particulièrement apprécié des visiteurs grâce à son éclairage nocturne, son architecture orientale et son atmosphère historique unique.
    `,

                facts: [
                    "Situé dans la vieille partie de Tachkent",
                    "Porte le nom d’Abu Bakr Kaffal Shashi",
                    "L’un des lieux les plus sacrés d’Ouzbékistan",
                    "Le Coran d’Othman y est conservé",
                    "La médersa Barak Khan est l’un des principaux monuments du complexe",
                    "Comprend des monuments historiques datant du XVIe siècle",
                    "Accueille chaque année des milliers de touristes",
                    "Célèbre pour son architecture islamique et orientale",
                    "Très apprécié pour son éclairage nocturne",
                    "L’un des principaux centres religieux et culturels de Tachkent"
                ],

                images: [
                    hazratiImom1,
                    hazratiImom2,
                    hazratiImom3
                ]
            },
            {
                title: "Bazar Chorsu — Le cœur de l’Orient",

                content: `
Le bazar Chorsu est l’un des endroits les plus animés et les plus colorés de Tachkent.

On y trouve de nombreux produits traditionnels comme les épices, les fruits frais, le pain et les plats nationaux ouzbeks.

Son immense dôme bleu et son atmosphère vivante attirent aussi bien les habitants que les touristes.

Le bazar Chorsu n’est pas seulement un lieu de commerce, mais également un centre important de la vie culturelle et sociale. Les habitants et les visiteurs s’y retrouvent pour découvrir la culture ouzbèke, goûter aux plats traditionnels et échanger avec les autres.

Le célèbre dôme du bazar Chorsu est devenu l’un des symboles de Tachkent et beaucoup de visiteurs aiment se photographier devant celui-ci.

Le marché accueille également différents événements culturels et sociaux.
    `,

                details: `
Le bazar Chorsu est l’un des sites les plus célèbres de Tachkent et accueille chaque jour des milliers de visiteurs.

Les alentours du marché mélangent l’architecture moderne et les bâtiments historiques, créant une atmosphère unique où les touristes et les habitants profitent ensemble de cet espace.

Depuis des siècles, Chorsu est un important centre commercial où les marchands, les voyageurs et la population locale échangent des produits et des traditions.

Aujourd’hui, il reste l’un des meilleurs endroits pour découvrir la culture authentique de l’Ouzbékistan, déguster la cuisine nationale et ressentir l’ambiance des marchés traditionnels orientaux.
    `,

                facts: [
                    "Situé au centre de Tachkent",
                    "Accueille des milliers de visiteurs chaque jour",
                    "Mélange l’architecture moderne et les bâtiments historiques",
                    "Centre d’activités culturelles et sociales",
                    "Célèbre pour ses épices, fruits, pains et plats nationaux",
                    "Son grand dôme est l’un des symboles de Tachkent",
                    "Un lieu très apprécié pour la photographie",
                    "Un point de rencontre entre habitants et touristes",
                    "Les visiteurs peuvent y découvrir la cuisine traditionnelle ouzbèke",
                    "L’un des marchés traditionnels les plus célèbres d’Ouzbékistan"
                ],

                images: [chorsu1, chorsu2, chorsu3,]
            },
            {
                title: "Place Amir Temur — Tachkent",

                content: `
La place Amir Temur est l’un des lieux les plus célèbres et les plus importants du centre de Tachkent.

Cette place a été créée en l’honneur d’Amir Temur, le grand commandant et fondateur de l’Empire timouride.

Entourée d’hôtels, de musées et de magnifiques jardins, elle représente l’identité historique et moderne de la ville.

Au centre de la place se trouve le monument d’Amir Temur, considéré comme l’un des héros nationaux de l’Ouzbékistan.

Aujourd’hui, la place est un lieu important pour les événements culturels, les rassemblements publics et le tourisme.
    `,

                details: `
La place Amir Temur est l’un des endroits les plus visités de Tachkent et accueille chaque jour des milliers de personnes.

Les environs de la place combinent une architecture moderne avec des bâtiments historiques, créant une atmosphère unique où les habitants et les touristes aiment passer du temps.

Cette place n’a pas seulement une importance historique, elle représente également le centre de la vie moderne de la capitale.

On y trouve de nombreux restaurants, cafés, magasins et espaces de loisirs offrant des conditions confortables aux visiteurs.

Le monument d’Amir Temur situé au centre de la place est très respecté et constitue l’un des endroits les plus photographiés de Tachkent.
    `,

                facts: [
                    "Située au centre de Tachkent",
                    "Créée en l’honneur d’Amir Temur",
                    "Le monument d’Amir Temur se trouve au centre de la place",
                    "Visitée par des milliers de personnes chaque jour",
                    "Entourée de bâtiments modernes et de sites historiques",
                    "De nombreux restaurants, cafés et magasins se trouvent à proximité",
                    "Un lieu agréable pour les touristes et les habitants",
                    "Amir Temur est considéré comme un héros national de l’Ouzbékistan",
                    "L’un des lieux les plus photographiés de Tachkent",
                    "Un important centre culturel et social de la ville"
                ],

                images: [amir1, amir2, amir3,]
            },
            {
                title: "Centre de la Civilisation Islamique — Tachkent",

                content: `
Le Centre de la Civilisation Islamique d’Ouzbékistan est l’un des plus grands et des plus modernes complexes culturels et éducatifs de Tachkent.

Le centre est situé près du complexe Hazrati Imam et a été construit afin de présenter au monde le riche patrimoine islamique de l’Ouzbékistan ainsi que les contributions des grands savants de la région.

Le complexe combine l’architecture orientale traditionnelle avec un design moderne et se distingue par son immense dôme bleu et son apparence majestueuse.

On y présente des manuscrits anciens, des objets historiques, des technologies interactives et des informations uniques sur la civilisation islamique.
    `,

                details: `
L’objectif principal du Centre de la Civilisation Islamique est de mettre en valeur la contribution des grands savants ouzbeks et de la civilisation islamique au développement de la science et de la culture mondiale.

À l’intérieur du complexe se trouvent :
- La salle du Coran et des manuscrits anciens
- Des sections consacrées à la Première et à la Deuxième Renaissance
- Le patrimoine de grands savants comme l’Imam Boukhari, Al-Biruni et Avicenne (Ibn Sina)
- Des technologies multimédias modernes et l’intelligence artificielle
- Une bibliothèque scientifique et des salles de conférence

L’intérieur du centre est également remarquable avec ses motifs orientaux traditionnels, ses grandes colonnes et son système d’éclairage moderne.

Le complexe représente le lien entre le riche héritage historique de l’Ouzbékistan et le développement scientifique contemporain.
    `,

                facts: [
                    "Situé à Tachkent",
                    "Construit près du complexe Hazrati Imam",
                    "Possède un immense dôme de 65 mètres",
                    "L’un des complexes muséaux les plus modernes d’Ouzbékistan",
                    "Consacré à l’histoire islamique et au patrimoine des grands savants",
                    "Présente des manuscrits anciens et des objets historiques",
                    "Utilise des technologies multimédias modernes",
                    "Combine l’architecture orientale et le design contemporain",
                    "Attire des touristes locaux et internationaux",
                    "Présente la contribution des savants ouzbeks à la civilisation mondiale"
                ],

                images: [
                    muzey1,
                    muzey2,
                    muzey3,
                ]
            },
            {
                title: "Métro de Tachkent — Le musée souterrain",

                content: `
Le métro de Tachkent est l’un des systèmes de transport les plus célèbres et les plus modernes de la capitale de l’Ouzbékistan.

Il a été inauguré en 1977 et est devenu le premier métro d’Asie centrale.

Le métro de Tachkent est connu non seulement comme un moyen de transport pratique, mais aussi comme un véritable musée d’art souterrain.

Chaque station possède son propre design unique, décoré avec des motifs nationaux, des colonnes en marbre, un système d’éclairage élégant et des éléments artistiques.

Le métro relie rapidement et efficacement les différents quartiers de la ville et transporte chaque jour des milliers de passagers.
    `,

                details: `
La construction du métro de Tachkent a commencé après le puissant tremblement de terre de 1966.

Les stations ont été conçues avec une grande résistance sismique afin de supporter de forts tremblements de terre.

Le réseau du métro comprend :
- La ligne Chilonzor
- La ligne Ouzbékistan
- La ligne Yunusobod
- La ligne circulaire

Les stations les plus célèbres et les plus belles sont :
- Station Kosmonavtlar
- Station Alisher Navoi
- Station Pakhtakor
- Station Mustaqillik Maydoni

L’intérieur du métro combine les décorations nationales, le modernisme soviétique et les traditions architecturales orientales, attirant de nombreux visiteurs.

Depuis 2018, les photos et les vidéos sont autorisées dans le métro, ce qui a rendu le métro de Tachkent encore plus populaire auprès des voyageurs.
    `,

                facts: [
                    "Ouvert en 1977",
                    "Premier métro d’Asie centrale",
                    "Possède 4 lignes principales",
                    "Comprend plus de 50 stations",
                    "Chaque station possède un design unique",
                    "Construit avec des technologies résistantes aux séismes",
                    "La station Kosmonavtlar est l’une des plus célèbres",
                    "La photographie était interdite jusqu’en 2018",
                    "Utilisé par des centaines de milliers de passagers chaque jour",
                    "Connu comme un musée d’art souterrain",
                    "Les stations sont décorées avec du marbre et des motifs nationaux",
                    "L’un des symboles de la Tachkent moderne",
                    "Attire de nombreux touristes internationaux",
                    "Mélange l’architecture orientale et le design moderne",
                    "L’un des plus beaux métros d’Asie centrale",
                    "Relie les différents quartiers de la capitale",
                    "Possède une grande importance historique et culturelle",
                    "Sa construction a commencé après le séisme de 1966",
                    "Chaque station raconte sa propre histoire",
                    "Il est particulièrement magnifique avec l’éclairage nocturne"
                ],

                images: [metro1, metro2, metro3,]
            }
        ]
    }
};
export default tashkent;